import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import Layout from './components/Layout';
import Home from './pages/HomePage.jsx';
import OficinasVeraoPage from './pages/OficinasVeraoPage.jsx';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';
import RegulamentoPage from './pages/RegulamentoPage.jsx';
import SobreNosPage from './pages/SobreNosPage.jsx';
import ClubeBarcoPage from './pages/ClubeBarcoPage.jsx';
import FestasAniversario from './pages/FestasAniversarioPage.jsx';
import AgendamentoPage from './pages/AgendamentoPage.jsx';
import ValePresentePage from './pages/ValePresentePage.jsx';
import ContatoPage from './pages/ContactoPage.jsx';
import SolicitarPage from './pages/SolicitarPage.jsx';
import InfoFestaPage from './pages/InfoFestaPage.jsx';
import { CartProvider } from './context/CartContext.jsx';
import MeusParticipantesPage from './pages/MeusParticipantesPage.jsx';
import AdminDashboardPage from './pages/AdminDashboardPage.jsx';
import AnalyticsPage from './pages/AnalyticsPage.jsx';
import EventsManagementSystem from './pages/EventsManagementPage.jsx';
import MeusAgendamentos from './pages/MeusAgendamentos.jsx';
import HistoricoPage from './pages/HistoricoPage.jsx';
import CostsManagementPage from './pages/CostManagementPage.jsx';
import PaymentCheckout from './components/PaymentCheckout.jsx';
import CompletarRegistoPage from './pages/CompletarRegistoPage.jsx';
import LoginPage from './pages/LoginPage.jsx';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || 'YOUR_GOOGLE_CLIENT_ID';

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/oficinas-de-verao-2025" element={<OficinasVeraoPage />} />
            <Route path="/sobre-nos" element={<SobreNosPage />} />
            <Route path="/clube-barco" element={<ClubeBarcoPage />} />
            <Route path="/festas-aniversario" element={<FestasAniversario />} />
            <Route path='/agendamento' element={<AgendamentoPage />} />
            <Route path='/vale-presente' element={<ValePresentePage />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicyPage />} />
            <Route path="/regulamento" element={<RegulamentoPage />} />
            <Route path="contacto" element={<ContatoPage />} />
            <Route path="/booking-calendar" element={<SolicitarPage />} />
            <Route path='/info-festas-de-aniversário' element={<InfoFestaPage />} />
            <Route path="/meus-participantes" element={<MeusParticipantesPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
            <Route path="/admin/analytics" element={<AnalyticsPage />} />
            <Route path="/admin/eventos" element={<EventsManagementSystem/>} />
            <Route path="/meus-agendamentos" element={<MeusAgendamentos />} />
            <Route path="/historico" element={<HistoricoPage />} />
            <Route path="/admin/custos" element={<CostsManagementPage />} />
            <Route path="/pagamento" element={<PaymentCheckout />} />
            <Route path="/completar-registo" element={<CompletarRegistoPage />} />
            <Route path="/login" element={<LoginPage />} />
          </Route>
        </Routes>
      </Router>
      </CartProvider>
    </GoogleOAuthProvider>
  );
}

export default App;